export enum AlertType {
  'EXTERNAL' = 'EXTERNAL',
  'HEARTBEAT' = 'HEARTBEAT',
  'INTELLIGENT' = 'INTELLIGENT',
  'TEMPLATE' = 'TEMPLATE',
  'THRESHOLD' = 'THRESHOLD',
}
